/* eslint-disable @typescript-eslint/naming-convention */
export class ReportCategoryDto {
  /** GUID */
  public ReportCategoryID: string;
  public ReportCategoryName: string;
  public IsActive: boolean;
}
